module.exports = __webpack_public_path__ + "img/nt107-00-81-1.asm.61a20f72.jpg";